import Menu from "./menu/menu.js";
import Search from "./search/search.js";

class Header {
	#elements;
	#state;
	#menu;
	#search;
	/** Keep breakpoint in sync with CSS */
	#breakpoint = window.matchMedia("(width >= 48rem)");

	/**
	 * @param {HTMLElement} element
	 */
	constructor(element) {
		this.#elements = {
			menu: /** @type {HTMLDivElement|null} */ (
				element.querySelector(".js-HeaderMenu")
			),
			search: /** @type {HTMLDivElement|null} */ (
				element.querySelector(".js-HeaderSearch")
			),
		};

		this.#state = {
			open: null,
			view: this.#breakpoint.matches ? "large" : "small",
		};

		if (this.#elements.menu) {
			this.#menu = new Menu(this.#elements.menu, this.#render.bind(this));
		}

		if (this.#elements.search) {
			this.#search = new Search(this.#elements.search, this.#render.bind(this));
		}

		this.#breakpoint.addEventListener(
			"change",
			this.#onBreakpointChange.bind(this),
		);
	}

	#onBreakpointChange() {
		if (this.#breakpoint.matches) {
			if (this.#state.view === "small") {
				this.#menu?.show();
				this.#search?.show();
				this.#render();
				this.#state.view = "large";
			}
		} else if (this.#state.view === "large") {
			this.#menu?.hide();
			this.#search?.hide();
			this.#render();
			this.#state.view = "small";
		}
	}

	/**
	 * @param {"menu"|"search"} [element]
	 * @param {boolean} [isOpen]
	 */
	#render(element, isOpen) {
		this.#elements.menu?.toggleAttribute("hidden", false);
		this.#elements.search?.toggleAttribute("hidden", false);

		if (element === "search" && isOpen) {
			this.#elements.menu?.toggleAttribute("hidden", true);
		}

		if (element === "menu" && isOpen) {
			this.#elements.search?.toggleAttribute("hidden", true);
		}
	}
}

export default Header;
